import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PublicLayout } from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import Download from "@/pages/Download";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/admin/AdminLayout";
import AdminOverview from "@/admin/pages/Overview";
import AdminLeads from "@/admin/pages/Leads";
import AdminOrders from "@/admin/pages/Orders";
import AdminUsers from "@/admin/pages/Users";
import AdminRestaurants from "@/admin/pages/Restaurants";
import AdminRiders from "@/admin/pages/Riders";
import AdminDisputes from "@/admin/pages/Disputes";
import AdminSettlements from "@/admin/pages/Settlements";
import AdminSettings from "@/admin/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Marketing website (gated by maintenance mode) */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/download" element={<Download />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Web Admin Dashboard */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="restaurants" element={<AdminRestaurants />} />
            <Route path="riders" element={<AdminRiders />} />
            <Route path="disputes" element={<AdminDisputes />} />
            <Route path="settlements" element={<AdminSettlements />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Legacy hidden submissions view -> new admin leads module */}
          <Route path="/admin-view-submissions" element={<Navigate to="/admin/leads" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
